/**
 * Audit log read API.
 *
 * BUILD_SPEC.md §6 doesn't formalize an audit-list endpoint — §10.1
 * lists `/admin/audit` as a route but the server contract is implicit.
 * We added a paginated, admin-only GET in this milestone so the
 * audit-viewer page has something real to read.
 */

import { api } from "./client";
import type { AuditLog, Paginated } from "./types";

export interface ListAuditParams {
  action?: string;
  userId?: string;
  page?: number;
  limit?: number;
}

export async function listAuditLogs(params: ListAuditParams = {}): Promise<Paginated<AuditLog>> {
  const res = await api.get<Paginated<AuditLog>>("/audit", { params });
  return res.data;
}
